import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './CertificationSection.css';

const CertificationSection = () => {
  const [selectedImg, setSelectedImg] = useState(null);

  const certificates = [
    {
      id: 1,
      title: 'Java Professional Certification',
      issuer: 'Core2web Academy',
      image: '/assets/images/courses/java_certificate.png',
      description: 'Awarded for mastering Java Fundamentals, Advanced Java, and Industry Standard Practices.'
    },
    {
      id: 2,
      title: 'SuperX Journey Achievement',
      issuer: 'Core2web Academy',
      image: '/assets/images/courses/Superx_certificate.png',
      description: 'Recognition for successfully completing the intensive 15-phase SuperX learning roadmap.'
    },
    {
      id: 3,
      title: 'Quizeethon Excellence',
      issuer: 'Core2web Academy',
      image: '/assets/images/courses/Quizeethon_certificate.png',
      description: 'Special certification for outstanding performance in the technical Quizeethon challenges.'
    }
  ];

  return (
    <section className="ucp-section certification-section">
      <div className="certification-container">
        <motion.div
          className="certification-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="certification-subtitle">Validate Your Skills</span>
          <h2>Earn Industry-Recognized Certification</h2>
          <p>
            Gain credentials that matter. Our certifications are recognized by leading tech companies
            and validate your deep technical expertise.
          </p>
        </motion.div>

        <div className="certificates-grid">
          {certificates.map((cert, index) => (
            <motion.div
              key={cert.id}
              className="certificate-card"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              onClick={() => setSelectedImg(cert.image)}
            >
              <div className="certificate-image-wrapper">
                <img src={cert.image} alt={cert.title} loading="lazy" />
              </div>
              <div className="certificate-info">
                <h3>{cert.title}</h3>
                <p>{cert.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      <AnimatePresence>
        {selectedImg && (
          <motion.div
            className="certificate-modal-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedImg(null)}
          >
            <motion.div
              className="certificate-modal-content"
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              onClick={(e) => e.stopPropagation()}
            >
              <button className="close-modal" onClick={() => setSelectedImg(null)}>&times;</button>
              <img src={selectedImg} alt="Certificate Enlarged" />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

export default CertificationSection;
